import React from 'react'
import { Button } from 'src/components/atoms'

/**
 * 認可情報の取得には成功したが、利用できる組織が1件も無かったときの案内。
 *
 * org 単位の IP アクセス制限（boba-server #3479）では、許可外ネットワークからの
 * ログインはエラーにならず、制限対象の組織がレスポンスから除外されて返る。
 * 制限対象の組織しか持たないユーザーはここで 0 件になるため、案内が無いと
 * ログインには成功したのに何も表示されない状態になる。
 * 組織がまだ紐づいていないアカウントも同じく 0 件になるため、両方に触れている。
 */
const NoAuthorizations: React.FC = () => {
  return (
    <div style={{ padding: '20px' }}>
      <h2>ご利用できる組織がありません</h2>
      <p>
        アクセス元のネットワークが許可されていないか、アカウントに組織が紐づいていない可能性があります。
        <br />
        許可されたネットワークから接続しているかをご確認のうえ、ページを再読み込みしてください。
        <br />
        解消しない場合、お手数ですが、ログイン中のメールアドレスを添えて、管理者までご連絡ください。
      </p>
      <Button
        color="primary"
        size="large"
        title="ページを再読み込み"
        onClick={() => window.location.reload()}
      />
    </div>
  )
}

export default NoAuthorizations
